module.exports = {
  framer: require('./src/framer.js'),
  windows: require('./src/windows.js')
};



//////////////////
// WEBPACK FOOTER
// ./~/signal-windows/index.js
// module id = 114
// module chunks = 0